export const SUPER_USER = 21
